import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import './Higher.css';
import { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons";
import {getMessagemErro} from "../../../utils/erro";
import { exibeMensagemErro, setMensagensNaoLidas } from "../../../providers/actions";

import api from "../../../services/api";

const mapDispatchToProps = { exibeMensagemErro, setMensagensNaoLidas }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const MessageIcon =

// redux
connect(
	(mapStateToProps),
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				mensagensNaoLidas: 0
			};

			this.intervalId = null;
			this.consultarMensagensGestor = this.consultarMensagensGestor.bind(this);
		}


		render() {
			const user = this.props.user;
			const mensagensNaoLidas = user?.mensagensNaoLidas;
			
			return (
				<>
					{(user && user.isCliente) &&
						<Link to="/inbox">   
							<div className="div-mensagens">
								<span> 	
									<FontAwesomeIcon title="Mensagens" icon={faBullhorn} className="icon-menu-higher"/>
								</span>
								{mensagensNaoLidas > 0 &&
									<span className="tag-counter">{mensagensNaoLidas < 100 ? mensagensNaoLidas : '99+'}</span>
								}
							</div>
						</Link>
					}
				</>
			);
		}

		componentDidMount(){
			const { user } = this.props;
			if(user && user.isCliente){
				this.consultarMensagensGestor();
				this.intervalId = setInterval(() => { this.consultarMensagensGestor();}, 60000);
			}
		}

		componentWillUnmount() {
			if (this.intervalId) {
				clearInterval(this.intervalId);
			}
		}

		consultarMensagensGestor() {
			api.get('/api/mensagem-gestor/qtd-nao-lidas')
				.then(response => { 
					const mensagensNaoLidas = response.data;
					this.props.setMensagensNaoLidas(mensagensNaoLidas);
					})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a quantidade de mensagens.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});
		}
		
	}

); // redux 